<template>
  <div
    ref="pushNotificationModal"
    id="pushNotificationModal"
    class="modal modal-v modal-v--normal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="pushNotificationModalLabel"
    aria-hidden="true"
  >

    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <img class="profile-show__modal-image" src="/img/viluu/background/notification_icon.png" alt="coins">
          <div>
            <h2 class="title title--medium">
              {{ trans.get('profile:modal.push_notification.header') }}
            </h2>

            <p class="desc desc--lightgrey">
              {{ trans.get('profile:modal.push_notification.slogan') }}
            </p>
          </div>

          <div v-if="error" class="alert alert-danger">
            {{ error }}
          </div>

          <button v-show="loading" type="button" class="button button__fill">
            <LoaderComponent :show="true"></LoaderComponent>
          </button>
          <button v-show="!loading" type="button" class="button button__fill" @click="acceptAction">
            {{ trans.get('profile:modal.push_notification.accept') }}
          </button>

          <button type="button" class="button button__link button__link--underline" data-dismiss="modal" @click="delayAction">
            {{ trans.get('profile:modal.push_notification.delay') }}
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import LoaderComponent from '../components/PaymentV1/LoaderComponent';
import { getToken } from 'firebase/messaging';
import messaging from '../firebase';

export default {
  name: 'PushNotificationModal',
  components: { LoaderComponent },
  props: {},
  data() {
    return {
      open: false,
      loading: false,
      revealing: {
        amount: 5,
        unit: 'm'
      },
      delay: {
        amount: 5,
        unit: 'd'
      },
      error: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    storageHasPushKey: function () {
      return 'hasPush.' + this.user.id;
    },
    storageDateKey: function () {
      return 'nextPushNotificationModal.' + this.user.id;
    },
  },
  watch: {
    open(val) {
      if (val) {
        $(this.$refs.pushNotificationModal).modal('show');
      } else {
        $(this.$refs.pushNotificationModal).modal('hide');
        this.delayAction();
      }
    },
  },
  methods: {
    acceptAction: function () {
      this.error = null;

      if (messaging === undefined) {
        this.error = this.trans.get('profile:modal.push_notification.other_error');
        return;
      }

      this.tryRequestPermission(1);
    },
    tryRequestPermission(attempt = 1) {
      this.loading = true;

      Notification.requestPermission()
        .then(() => getToken(messaging))
        .then((token) => {
          const csrf = document.querySelector('meta[name="csrf-token"]').content;
          const xhr = new XMLHttpRequest();
          xhr.open('POST', '/ajax/devices', true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.send(JSON.stringify({
            source: 'web',
            token: token,
            _token: csrf
          }));

          this.loading = false;
          this.open = false;
          window.localStorage.setItem(this.storageHasPushKey, true);
        })
        .catch((err) => {
          console.log('tryRequestPermission error:');
          console.log(attempt);
          console.log(err);
          console.log(err.code);
          this.loading = false;
          if (attempt === 1) {
            setTimeout(() => {
              this.tryRequestPermission(attempt += 1);
            }, 1000);
            return;
          }

          if (err.code === 'messaging/permission-blocked') {
            this.error = this.trans.get('profile:modal.push_notification.permission_error');
          } else {
            this.error = this.trans.get('profile:modal.push_notification.other_error');
          }
        });
    },
    delayAction: function () {
      this.open = false;
      let date = moment().add(this.delay.amount, this.delay.unit);
      window.localStorage.setItem(this.storageDateKey, date.toISOString());
    },
  },
  mounted() {
    let vm = this;

    /**
     * Disable popup for safari browser
     */
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      return;
    }
    this.$eventHub.$on('PushNotificationModalOpen', () => {
      vm.open = true;
    });

    $(this.$refs.pushNotificationModal).on('hidden.bs.modal', function (e) {
      vm.open = false;
    });

    if (window.localStorage.getItem(this.storageHasPushKey)) {
      // return if already set
      return;
    }

    let localNextDate = moment(window.localStorage.getItem(this.storageDateKey));
    if (!localNextDate.isValid()) {
      // modify first revealing
      localNextDate = moment(this.user.filled_at).add(this.revealing.amount, this.revealing.unit);
    }

    if (this.user.filled_at && localNextDate.isBefore() && window.globals.show_push_notification_modal) {
      // open if time is correct
      vm.open = true;
    }
  }
};
</script>

<style scoped>

</style>
